import { Loading } from '@social-solutions/component-library';
import theme from 'theme';

function LoadingIndicator() {
    return <Loading color={theme.black} fontSize={'18px'} type={'bubbles'} />;
}

export default LoadingIndicator;

